import { connect } from 'react-redux';
import {
  isLastReview,
  getHasReviewsSection,
  getIsNewVariant,
} from 'src/store/reviews/selectors';

import HotelReviewsMobile from '../../components/HotelReviewsMobile/HotelReviewsMobile';

const mapStateToProps = (state) => ({
  isLastReview: isLastReview(state),
  hasReviews: getHasReviewsSection(state),
  isNewReviewsVariant: getIsNewVariant(state),
});

export default connect(mapStateToProps)(HotelReviewsMobile);
